import _ from "lodash";
import { forwardRef, SetStateAction, useEffect, useRef, useState } from "react";
import {
  convertDataToWorkbook,
  hasAccess,
  makeRequest,
  mapRowId,
} from "../../common/commonFunctions";
import moment from "moment";
import { WindowedMenuList } from "react-windowed-select";
import axios from "axios";
import {
  Card,
  CardContent,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import Select from "react-select";
// import { WindowedMenuList } from "react-windowed-select";
import { constants, EndPoint, messages } from "../../common/constants";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import SearchIcon from "@mui/icons-material/Search";
import SupplyManagementGrid from "./Grid";
import RefreshIcon from "@mui/icons-material/Refresh";
import excel from "../../assets/images/excel.svg";
import { exportMultipleSheetsAsExcel } from "ag-grid-enterprise";
import { Split } from "@geoffcox/react-splitter";
import SummaryPieChart from "../../components/SummaryPieChart";
import * as XLSX from "xlsx";
import SpinnerFullScreen from "../../components/SpinnerFullScreen";
import CancelIcon from "@mui/icons-material/Cancel";
import { toast, ToastContainer } from "react-toastify";
import swal from "sweetalert";
import { serviceAPIMapping } from "../../config/service-api-mapping";
import { pageConstant } from "../../config/pageConstant";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Icon } from "@iconify/react";
import { isServiceHealthy } from "../../utils/API";

const SupplyManagement = () => {
  const [filteredSupplyRows, setFilteredSupplyRows] = useState<any>([]);
  const [supplyRows, setSupplyRows] = useState<any>([]);
  const [snackbarMessage, setSnackbarMessage] = useState<any>("");
  const [refLoanReturns, setRefLoanReturns] = useState<any>(null);
  const [open, setOpen] = useState(false);
  const [gridApiSec, setGridApiSec] = useState<any>(null);
  const [heightAG_1] = useState(84);
  const [excelFileName, setExcelFileName] = useState("");
  const [isBulkUploadRunning, setIsBulkUploadRunning] = useState(false);
  const [rowsToSkip, setRowsToSkip] = useState<any>([]);
  const [excelLoader, setExcelLoader] = useState(false);
  const ref: any = useRef(null);
  const [lastUpdatedDate, setLastUpdatedDate] = useState(
    moment(new Date()).format("MM/DD/yyyy HH:mm")
  );
  const [groupByLenderData, setGroupByLenderData] = useState<any>({
    labels: [],
    values: [],
  });
  const [groupByTickerData, setGroupByTickerData] = useState<any>({
    labels: [],
    values: [],
  });
  const [date, setDate] = useState(moment());
  const [isInitialRefresh, setIsInitialRefresh] = useState(true);
  const [showScreenLoader, setShowScreenLoader] = useState<boolean>(false);
  const [showGetDataLoader, setShowGetDataLoader] = useState<boolean>(false);
  const [isSmallerDeviceRes, setIsSmallerDeviceRes] = useState<boolean>(
    window?.innerWidth < 992
  );
  const [isRegshoFilterActive, setIsRegshoFilterActive] =
    useState<boolean>(false);

  const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  useEffect(() => {
    const groupByLender = _.groupBy(filteredSupplyRows, "lender");
    const groupByTicker = _.groupBy(filteredSupplyRows, "ticker");
    const groupByLenderLabelValue: any[] = [];
    const groupByTickerLabelValue: any[] = [];
    Object.entries(groupByTicker).map(([key, value]) => {
      value.map((item: any) => {
        item.value = item.value && _.isNumber(item.value) ? item.value : 0;
      });
      const totalValue = _.sumBy(value, "value");
      groupByTickerLabelValue.push({
        label: key,
        value: totalValue ? totalValue : 0,
      });
    });
    Object.entries(groupByLender).map(([key, value]) => {
      value.map((item: any) => {
        item.value = item.value && _.isNumber(item.value) ? item.value : 0;
      });
      const totalValue = _.sumBy(value, "value");
      groupByLenderLabelValue.push({
        label: key,
        value: totalValue ? totalValue : 0,
      });
    });
    const top10GroupByTicker = _.sortBy(groupByTickerLabelValue, "value")
      .reverse()
      .slice(0, 10);
    const top10GroupByLender = _.sortBy(groupByLenderLabelValue, "value")
      .reverse()
      .slice(0, 10);
    setGroupByLenderData({
      labels: _.map(top10GroupByLender, "label"),
      values: _.map(top10GroupByLender, "value"),
    });
    setGroupByTickerData({
      labels: _.map(top10GroupByTicker, "label"),
      values: _.map(top10GroupByTicker, "value"),
    });
  }, [filteredSupplyRows]);
  const [isSupplyPopupOpen, setIsSupplyPopupOpen] = useState(false);
  const [supplyForm, setSupplyForm] = useState({
    lender: "",
    ticker: "",
    quantity: "",
    rate: "",
  });
  const [supplyFormErrors, setSupplyFormErrors] = useState({
    lender: false,
    ticker: false,
    quantity: false,
    rate: false,
  });
  const validateSupplyForm = () => {
    const value = supplyForm.rate?.trim();
    const cleanedRate = value?.replace(".", "");
    const isAllZeroRate =
      value !== "" && /^0+$/.test(cleanedRate || "") && cleanedRate?.length > 1;

    const quantityError =
      !supplyForm.quantity ||
      !/^\d+$/.test(supplyForm.quantity) ||
      Number(supplyForm.quantity) < 1 ||
      supplyForm.quantity.length > 12;

    const errors: any = {
      lender: !supplyForm.lender,
      ticker: !supplyForm.ticker,
      quantity: quantityError,
      rate: isAllZeroRate,
    };

    setSupplyFormErrors(errors);
    return !Object.values(errors).some((e) => e);
  };


  const [tickerOptions, setTickerOptions] = useState<any[]>([]);
  const [selectedTicker, setSelectedTicker] = useState<any>(null);

  const getTickers = async () => {
    const accountId = window.localStorage.getItem("activeAccountCode");
    const token = window.localStorage.getItem("refreshtoken");
    const header = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const raw = JSON.stringify({ pageNumber: 0, pageSize: 0 });
      const res = await axios.post(
        `${serviceAPIMapping["SECMASTER-SERVICE"].apiRouteURL}${EndPoint.secMaster}?account_id=${accountId}`,
        raw,
        { headers: header }
      );
      if (res.status === 200) {
        const tickerData = res.data;
        const options = tickerData.map((item: any) => ({
          value: item.ticker,
          label: `${item.ticker} - ${item.name}`,
          cusip: item.cusip,
          price: item.price,
        }));
        setTickerOptions(options);
        // setTickerMap(map);
      }
    } catch (err) {
      console.error("Ticker fetch error", err);
    }
  };

  const [lenderOptions, setLenderOptions] = useState<any[]>([]);
  const [selectedLender, setSelectedLender] = useState<any>(null);

  const getLenders = async () => {
    try {
      const accountId = localStorage.getItem("activeAccountCode");
      const token = localStorage.getItem("refreshtoken");

      if (!accountId || !token) {
        setLenderOptions([]);
        return;
      }

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      const baseUrl =
        serviceAPIMapping["SUPPLYMANAGEMENT-SERVICE"]?.apiRouteURL;
      const endpoint = EndPoint.getLenders;
      const url = `${baseUrl}${endpoint}?account_id=${accountId}`;

      const response = await axios.post(url, {}, { headers });

      if (response?.data && Array.isArray(response.data)) {
        const uniqueLenders: SetStateAction<any[]> = [];

        const seen = new Set();
        response.data.forEach((item: any) => {
          const name = item.shortName?.trim();
          if (name && !seen.has(name)) {
            seen.add(name);
            uniqueLenders.push({
              label: name,
              value: name,
            });
          }
        });

        setLenderOptions(uniqueLenders);
      } else {
        setLenderOptions([]);
      }
    } catch (error) {
      console.error(" Error loading lenders:", error);
      setLenderOptions([]);
    }
  };

  const submitSupplyData = async () => {
    const isValid = validateSupplyForm();
    if (!isValid) {
      toast.error("Invalid Quantity – Must be a 12 digits.");
      return;
    }

    const accountId = localStorage.getItem("activeAccountCode");
    const token = localStorage.getItem("refreshtoken");

    if (!token || !accountId) {
      toast.error("Missing account ID or token.");
      return;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const quantity = Number(supplyForm.quantity);
    const rate = Number(supplyForm.rate);
    const value = quantity * selectedTicker?.price;

    const payload = [
      {
        sec_id: supplyForm.ticker,
        qty: quantity,
        value: value,
        rate: rate,
        lender: selectedLender?.label || supplyForm.lender,
        date: new Date(),
        sec_id_type: "T",
      },
    ];

    try {
      const response = await axios.post(
        `${serviceAPIMapping["SUPPLYMANAGEMENT-SERVICE"].apiRouteURL}${EndPoint.saveLenderDetailsList}?account_id=${accountId}`,
        payload,
        { headers }
      );

      if (response.status === 200) {
        swal({
          icon: "success",
          title: "Success",
          text: "Lender data submitted successfully.",
          timer: 1500,
          buttons: undefined,
        });

        setSupplyForm({
          lender: "",
          ticker: "",
          quantity: "",
          rate: "",
        });

        const data = response?.data;

        if (data && data.length > 0) {
          const obj = data[0];
          const resObj = {
            ...obj,
            qty: !_.isEmpty(obj.qty) ? parseFloat(obj.qty) : 0,
            rate: !_.isEmpty(obj.rate) ? parseFloat(obj.rate) : 0,
            price: !_.isEmpty(obj.price) ? parseFloat(obj.price) : 0,
            value: !_.isEmpty(obj.value) ? parseFloat(obj.value) : 0,
            isRegshoThreshold: obj.isRegshoThreshold ? "Yes" : "No",
          };
          const resList = [resObj];

          setSupplyRows((previousRows: any) => {
            const currentRows = [...previousRows];
            const insertRows = _.differenceBy(
              resList,
              currentRows,
              "availability_id"
            );
            const uniq = _.uniqBy(insertRows, "availability_id");
            return [...uniq, ...currentRows];
          });
        }

        setSelectedLender(null);
        setSelectedTicker(null);
        setIsSupplyPopupOpen(false);
      }
    } catch (error) {
      console.error("error:", error);
      toast.error("Error occurred while submitting.");
    }
  };

  useEffect(() => {
    if (isInitialRefresh) {
      getSupplyServiceHealth();
      getSecmasterServiceHealth();
      setIsInitialRefresh(false);
    }
  }, []);

  const getSupplyServiceHealth = async () => {
    await isServiceHealthy(
      `${serviceAPIMapping["SUPPLYMANAGEMENT-SERVICE"].apiRouteURL}/${EndPoint.actuator}`
    ).then((response: any) => {
      if (!response?.ok || response?.status === 503) {
        setSnackbarMessage(`Supply${messages.serviceDownMessage}`);
        setOpen(true);
      } else {
        refreshGrid();
        getLenders();
      }
    });
  };

  const getSecmasterServiceHealth = async () => {
    await isServiceHealthy(
      `${serviceAPIMapping["SECMASTER-SERVICE"].apiRouteURL}/${EndPoint.actuator}`
    ).then((response: any) => {
      if (!response?.ok || response?.status === 503) {
        setSnackbarMessage(`${messages.TickerDownMessage}`);
        setOpen(true);
      } else {
        getTickers();
      }
    });
  };

  const getSupplyInfo = async () => {
    try {
      //Todo: use below data when we have perfect data
      // setShowGetDataLoader(true);
      // setSupplyRows([]);
      // setFilteredSupplyRows([]);
      const request = { date_in: moment(date).format("YYYY-MM-DD") };
      let accountId = window.localStorage.getItem("activeAccountCode");
      const token = window.localStorage.getItem("refreshtoken");
      const header = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      await axios
        .post(
          `${serviceAPIMapping["SUPPLYMANAGEMENT-SERVICE"].apiRouteURL}${EndPoint.getLenderDetails}?account_id=` +
            accountId,
          request,
          { headers: header }
        )
        .then((response: any) => {
          if (!response) {
            setOpen(true);
            setSnackbarMessage("Supply" + messages.serviceDownMessage);
          } else {
            const data = response?.data;
            if (data && !_.isEmpty(data)) {
              // const mappedRows = mapRowId(data);
              const uniqueRows = _.uniqBy(data, "availability_id");
              const updatedRows = uniqueRows.map((r: any) => ({
                ...r,
                qty: !_.isEmpty(r.qty) ? parseFloat(r.qty) : 0,
                rate: !_.isEmpty(r.rate) ? parseFloat(r.rate) : 0,
                price: !_.isEmpty(r.price) ? parseFloat(r.price) : 0,
                value: !_.isEmpty(r.value) ? parseFloat(r.value) : 0,
                isRegshoThreshold: r.isRegshoThreshold ? "Yes" : "No",
              }));
              setSupplyRows(updatedRows);
              setIsRegshoFilterActive((previousValue: boolean) => {
                if (previousValue) {
                  const filterRows = [...updatedRows]?.filter(
                    (s: any) => s?.isRegshoThreshold === "Yes"
                  );
                  setFilteredSupplyRows(
                    filterRows?.length > 0 ? filterRows : []
                  );
                } else {
                  setFilteredSupplyRows(updatedRows);
                }

                return previousValue;
              });
            } else {
              setSupplyRows([]);
              setFilteredSupplyRows([]);
            }
          }
        });
    } catch (err) {
      setSupplyRows([]);
      setFilteredSupplyRows([]);
      //setApiExceptionHandler({ isError: true, error: err })
    } finally {
      // setShowGetDataLoader(false);
    }
  };

  const refreshGrid = () => {
    setLastUpdatedDate(moment(new Date()).format("MM/DD/yyyy HH:mm"));
    getSupplyInfo();
  };

  const onRefreshGrid = () => {
    setShowGetDataLoader(true);
    setSupplyRows([]);
    setFilteredSupplyRows([]);
    refreshGrid();
    setTimeout(() => {
      setShowGetDataLoader(false);
    }, 300);
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === constants.clickaway) {
      return;
    }

    setOpen(false);
  };

  const onFilterTextChange = _.debounce((e: any) => {
    gridApiSec?.setQuickFilter(e.target.value);
  }, 800);

  useEffect(() => {
    if (isInitialRefresh) {
      setShowGetDataLoader(true);
      refreshGrid();
      setIsInitialRefresh(false);
      setTimeout(() => {
        setShowGetDataLoader(false);
      }, 300);
    }
  }, []);

  useEffect(() => {
    if (!isInitialRefresh) refreshGrid();
  }, [date]);

  function onExcelExport() {
    var spreadsheets = [];
    spreadsheets.push(
      refLoanReturns?.current?.api?.getSheetDataForExcel?.({
        sheetName: "Supply-Management",
      })!
    );

    exportMultipleSheetsAsExcel({
      data: spreadsheets,
      fileName: "supply-management.xlsx",
    });
  }

  const onFileUpload = (e: any) => {
    setExcelFileName(e.target.files[0].name);
    onUploadExcel(e);
  };

  const onClear = () => {
    setExcelFileName("");
  };

  const onUploadExcel = (e: any) => {
    makeRequest(
      "GET",
      `${URL.createObjectURL(e.target.files[0])}`,
      function (data: any) {
        const workbook = convertDataToWorkbook(data);
        populateGrid(workbook);
      },
      function (error: any) {
        //turning the flag false, so it can represents that the uploading process has been stoped.
        throw error;
      }
    );
  };

  const populateGrid = async (workbook: XLSX.WorkBook) => {
    // setExcelLoader(true)
    const tempArray: any = [];
    let tempObj: any = {};
    const rowsToSkip: any = [];
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const columns: Record<string, string> = {
      A: "name",
      C: "ticker",
      D: "quantity",
      E: "rate",
      F: "value",
      G: "date",
    };

    if (worksheet["A1"].v === columns.A) {
      let rowIndex = 2;
      if (worksheet["A" + rowIndex] === undefined) {
        const obj = {
          h: "",
          r: "<t>'</t>",
          t: "s",
          v: "",
          w: "",
        };
        worksheet["A" + rowIndex] = obj;
      }
      const expceFileRows: any =
        XLSX.utils.sheet_to_json(worksheet, { blankrows: false, defval: "" })
          .length + 1;
      try {
        while (expceFileRows >= rowIndex) {
          const row: any = {};
          const workRowA =
            worksheet["A" + rowIndex] == undefined
              ? ""
              : worksheet["A" + rowIndex].v;
          if (workRowA !== "#") {
            Object.keys(columns).forEach(function (column) {
              row[columns[column]] = worksheet[column + rowIndex]?.w;
            });

            row.status = constants.UI_STATUS_NEW;

            if (
              _.isUndefined(row.name) ||
              _.isNull(row.name) ||
              (_.isString(row.name) && _.isEmpty(row.name?.trim()))
            ) {
              row.status = constants.Error;
              rowsToSkip.push(rowIndex);
            }

            if (
              _.isUndefined(row.ticker) ||
              _.isNull(row.ticker) ||
              (_.isString(row.ticker) && _.isEmpty(row.ticker?.trim()))
            ) {
              row.status = constants.Error;
              rowsToSkip.push(rowIndex);
            }

            if (!row.quantity || isNaN(row.quantity) || row.quantity <= 0) {
              row.status = constants.Error;
              rowsToSkip.push(rowIndex);
            }

            // if (!row.rate || isNaN(row.rate)) {
            //   row.status = constants.Error
            //   rowsToSkip.push(rowIndex)
            // }

            // if (!row.price || isNaN(row.price) || row.price < 0) {
            //   row.status = constants.Error
            //   rowsToSkip.push(rowIndex)
            // }

            // if (!row.value || isNaN(row.value) || row.value < 0) {
            //   row.status = constants.Error
            //   rowsToSkip.push(rowIndex)
            // }

            if (
              !row.date ||
              _.isEmpty(row?.date) ||
              !moment(new Date(row?.date))?.isValid()
            ) {
              row.status = constants.Error;
              rowsToSkip.push(rowIndex);
            }

            if (row.status == constants.UI_STATUS_NEW) {
              tempObj = {
                lender: row?.name,
                sec_id: row?.ticker,
                qty:
                  _.isNaN(row?.quantity) || !row?.quantity
                    ? 0
                    : parseInt(row?.quantity),
                rate:
                  !row?.rate || _.isNaN(row?.rate) ? 0 : parseFloat(row?.rate),
                // price:
                //   !row?.price || _.isNaN(row?.price)
                //     ? 0
                //     : parseFloat(row?.price),
                value:
                  !row?.value || _.isNaN(row?.value)
                    ? 0
                    : parseFloat(row?.value),
                date: moment(row?.date)?.format("YYYY-MM-DD"),
                sm_id: 0,
                sec_id_type: "",
              };
              tempArray.push(tempObj);
            }
          }

          rowIndex++;
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        //setExcelLoader(false)
        if (rowsToSkip?.length > 0) {
          const uniqueRowIndex = _.uniq(rowsToSkip);
          setRowsToSkip(uniqueRowIndex);
          if (rowsToSkip?.length > 0) {
            swal({
              title: constants.UI_STATUS_WARNING,
              dangerMode: true,
              closeOnClickOutside: false,
              text: `These rows were skipped: ${_.join(rowsToSkip, ",")}`,
            });
          }
        }
        bulkUploadSupply(tempArray);
      }
    } else {
      setExcelLoader(false);
    }
  };

  const bulkUploadSupply = async (rowsToUpload: any) => {
    if (rowsToUpload && rowsToUpload?.length > 0) {
      try {
        setIsBulkUploadRunning(true);
        const request = rowsToUpload;
        const accountId = window.localStorage.getItem("activeAccountCode");
        const token = window.localStorage.getItem("refreshtoken");
        const header = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        };

        await axios
          .post(
            `${serviceAPIMapping["SUPPLYMANAGEMENT-SERVICE"].apiRouteURL}${EndPoint.saveLenderDetailsList}?account_id=` +
              accountId,
            JSON.stringify(request),
            {
              headers: header,
            }
          )
          .then((response) => {
            if (response && response?.status === 200) {
              toast.success("Lender details saved successfully");
              getSupplyInfo();
            }
          });
      } catch (error) {
        toast.error("Failed to save Lender details");
      } finally {
        onClear();
        setIsBulkUploadRunning(false);
      }
    }
  };

  useEffect(() => {
    setShowScreenLoader(
      excelLoader || isBulkUploadRunning || showGetDataLoader
    );
  }, [excelLoader, isBulkUploadRunning, showGetDataLoader]);

  const getCardHeight = () => {
    const offsetHeight = document?.getElementById("supply-title")?.offsetHeight;
    const divHeight = _.isUndefined(offsetHeight) ? 2 : offsetHeight + 12;

    return "calc(100% - " + divHeight + "px)";
  };

  useEffect(() => {
    // Function to handle the resize event
    function handleResize() {
      setIsSmallerDeviceRes(window.innerWidth <= 992);
    }

    // Add the event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getUI = () => {
    return (
      <>
        <Split initialPrimarySize={"70%"}>
          <div className="h-100">
            <SupplyManagementGrid
              rowData={filteredSupplyRows}
              height={heightAG_1}
              type="SupplyManagement"
              getBtnRef={(gridRef: any) => {
                setRefLoanReturns(gridRef);
              }}
              getGridApi={(gridApi: any) => {
                setGridApiSec(gridApi);
              }}
            />
          </div>
          <div className="h-100">
            <div className="d-flex flex-column h-100">
              <div className={`mb-1 h-50`}>
                <SummaryPieChart
                  title="Group by Lender (Top 10)"
                  summaryChartInfo={groupByLenderData}
                ></SummaryPieChart>
              </div>
              <div className={`mb-1 h-50`}>
                <SummaryPieChart
                  title="Group by Symbol (Top 10)"
                  summaryChartInfo={groupByTickerData}
                ></SummaryPieChart>
              </div>
            </div>
          </div>
        </Split>
      </>
    );
  };

  const getSmallerDevicesUI = () => {
    return (
      <div className="row" style={{ overflow: "auto" }}>
        <div style={{ height: "30vh" }} className="col">
          <SupplyManagementGrid
            rowData={supplyRows}
            height={heightAG_1}
            type="SupplyManagement"
            getBtnRef={(gridRef: any) => {
              setRefLoanReturns(gridRef);
            }}
            getGridApi={(gridApi: any) => {
              setGridApiSec(gridApi);
            }}
          />
        </div>
        <div className={`mb-1 h-100 row`}>
          <SummaryPieChart
            title="Group by Lender (Top 10)"
            summaryChartInfo={groupByLenderData}
          ></SummaryPieChart>
        </div>
        <div className={`mb-1 h-100 row`}>
          <SummaryPieChart
            title="Group by Symbol (Top 10)"
            summaryChartInfo={groupByTickerData}
          ></SummaryPieChart>
        </div>
      </div>
    );
  };

  const getDatePicker = () => {
    return (
      <>
        <div
          className={`pe-2 ${
            isSmallerDeviceRes ? "col col-sm-12 w-100 mt-1 w-100" : ""
          }`}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              disableFuture
              openTo="day"
              className="onFocusOutTermDateID"
              views={["year", "month", "day"]}
              maxDate={moment().toDate()}
              value={date}
              inputFormat="yyyy-MM-dd"
              InputProps={{
                notched: false,
                style: { fontSize: 13, color: "#212529" },
              }}
              onChange={(newValue: any) => {
                if (newValue && moment(newValue).isAfter(moment())) {
                  swal({
                    icon: "warning",
                    text: `The entered date cannot be greater than the current date.`,
                    dangerMode: false,
                    closeOnClickOutside: false,
                    buttons: ["No", "Yes"],
                  });
                } else {
                  setDate(newValue);
                }
              }}
              renderInput={(params: any) => (
                <TextField
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-input": {
                      height: "0.4rem",
                      width: "4.4rem",
                    },
                  }}
                  className="inputStyleNew"
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
        </div>
      </>
    );
  };

  const onRegshoFilterToggle = () => {
    setIsRegshoFilterActive(!isRegshoFilterActive);
  };

  useEffect(() => {
    const originalRows = [...supplyRows];
    if (isRegshoFilterActive) {
      const filterRows = [...originalRows]?.filter(
        (s: any) => s?.isRegshoThreshold === "Yes"
      );
      setFilteredSupplyRows(filterRows?.length > 0 ? filterRows : []);
    } else {
      setFilteredSupplyRows([...originalRows]);
    }
  }, [isRegshoFilterActive]);

  useEffect(() => {
    const returnInterval = setInterval(() => {
      setDate((previouDate: any) => {
        const isCurrentDate = moment().isSame(previouDate, "day");
        if(isCurrentDate){
          refreshGrid();
        }
        return previouDate;
      });

     
    }, 5000);
    return () => clearInterval(returnInterval);
  }, []);

  useEffect(() => {
    if (supplyRows && supplyRows?.length > 0) {
      setIsRegshoFilterActive((previousValue: boolean) => {
        if (previousValue) {
          const filterRows = [...supplyRows]?.filter(
            (s: any) => s?.isRegshoThreshold === "Yes"
          );
          setFilteredSupplyRows(filterRows?.length > 0 ? filterRows : []);
        } else {
          setFilteredSupplyRows(supplyRows);
        }

        return previousValue;
      });
    } else {
      setFilteredSupplyRows([]);
    }
  }, [supplyRows]);

  return (
    <>
      <Snackbar open={open} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="error"
          sx={{
            width: "100%",
            backgroundColor: "orange",
            textDecorationColor: "white",
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {showScreenLoader && <SpinnerFullScreen />}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        // closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        toastClassName={() =>
          "bg-white text-black border border-gray-300 rounded shadow-sm"
        }
      />

      <div id="supply-title" className="mb-1" style={{ paddingLeft: "20px" }}>
        Supply Management
      </div>

      <Card
        className={`${isSmallerDeviceRes ? "overflow-auto" : ""}`}
        style={{ height: getCardHeight() }}
      >
        <CardContent className="h-100 py-0">
          <div className="d-flex flex-row row">
            <div
              className={`d-flex flex-row justify-content-start col mb-0 mt-0 align-items-center ${
                isSmallerDeviceRes ? "col row mt-1" : ""
              }`}
            >
              <div
                style={{
                  width: isSmallerDeviceRes ? "60%" : "45%",
                  marginLeft: 0,
                }}
                className="d-flex flex-row align-content-center align-items-center"
              >
                <div className="globalfiltermaindivSec w-100">
                  <input
                    type="search"
                    placeholder="Global search..."
                    id="filter-text-box-sec"
                    onInput={onFilterTextChange}
                  />
                  <SearchIcon style={{ fontSize: "1rem", color: "#1e355e" }} />
                </div>

                <div className="d-flex flex-row ms-3 pt-2">
                  <div className="form-check d-flex align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={onRegshoFilterToggle}
                          checked={isRegshoFilterActive}
                        />
                      }
                      label={<Typography>Regsho</Typography>}
                      className="pe-3"
                    />
                  </div>
                </div>
              </div>

              {isSmallerDeviceRes && getDatePicker()}
            </div>

            <div
              className={`col d-flex align-items-center justify-content-end sm-md-mt-2-rem ${
                isSmallerDeviceRes ? "col row" : ""
              }`}
            >
              {!isSmallerDeviceRes && (
                <>
                  {getDatePicker()}

                  <button
                    className="btn btn-primary ms-2"
                    style={{ height: "35px" }}
                    onClick={() => setIsSupplyPopupOpen(true)}
                  >
                    Add Single Entry
                  </button>
                </>
              )}

              <a
                href="/supply-bulk-upload-template.xlsx"
                download
                className="float-end me-0 text-nowrap icon-cursor-pointer ms-2"
                title={"Download black template"}
              >
                <Icon
                  style={{
                    color: "#1E355E",
                    marginBottom: "0.1rem",
                    marginRight: "0.5rem",
                    height: "1.4rem",
                    width: "1.4rem",
                    cursor: "pointer",
                  }}
                  icon={"tdesign:file-download"}
                ></Icon>
              </a>

              <div className="upload-btn-main-div mt-1">
                {excelFileName === "" ? (
                  <button
                    className="excel-upload-btn float-end mb-1 mx-1"
                    disabled={
                      !hasAccess([
                        `${pageConstant.SUPPLY_MANAGEMENT}_RW`,
                        `${pageConstant.SUPPLY_MANAGEMENT}_ADMIN`,
                      ])
                    }
                  >
                    <input
                      type="file"
                      className="FileUpload"
                      onChange={onFileUpload}
                      accept=".xlsx,.xlsm,.xlsb,.xltx,.xltm,.xlt,.xls,.xls"
                      ref={ref}
                      disabled={
                        !hasAccess([
                          `${pageConstant.SUPPLY_MANAGEMENT}_RW`,
                          `${pageConstant.SUPPLY_MANAGEMENT}_ADMIN`,
                        ])
                      }
                    />
                    <div className="dropZoneOverlay">
                      {excelLoader === true ? (
                        <div className="spinner-border text-dark spinner-border-sm"></div>
                      ) : (
                        "Upload File"
                      )}
                    </div>
                  </button>
                ) : (
                  <div className="file-name me-3">
                    {excelFileName}
                    <CancelIcon
                      onClick={onClear}
                      style={{
                        color: "#E90909",
                        height: "0.9rem",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                )}
              </div>

              <div
                className={`borrowExceldnld ${isSmallerDeviceRes ? "col" : ""}`}
                onClick={onExcelExport}
                title="Download Excel"
              >
                <img
                  src={excel}
                  alt=""
                  style={{
                    height: "1.8rem",
                    width: "1.8rem",
                    cursor: "pointer",
                  }}
                />
              </div>

              <div
                className={`d-flex justify-content-end cursor-pointer pr-1 align-items-center ${
                  isSmallerDeviceRes ? "col" : ""
                }`}
                onClick={onRefreshGrid}
                title="Refresh Data"
              >
                <RefreshIcon
                  style={{
                    cursor: "pointer",
                    marginRight: "0.5rem",
                    color: "#1E355E",
                  }}
                />
                <div className="refreshsettimedateContract">
                  <div>Last updated on:</div>
                  <div>{lastUpdatedDate}</div>
                </div>
              </div>
            </div>
          </div>

          <hr className="my-0"></hr>

          {isSmallerDeviceRes ? <>{getSmallerDevicesUI()}</> : <>{getUI()}</>}
        </CardContent>
      </Card>

      <Dialog
        open={isSupplyPopupOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setIsSupplyPopupOpen(false);
          }
        }}
        disableEscapeKeyDown
        maxWidth="lg"
        PaperProps={{ sx: { minWidth: "400px" } }}
      >
        <DialogTitle sx={{ backgroundColor: "#1E355E" }}>
          <Typography sx={{ color: "white" }}>Single Entry</Typography>
        </DialogTitle>

        <DialogContent className="pb-0">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr",
              gap: "1rem",
              width: "100%",
              marginTop: "2%",
            }}
          >
            {/* Lender */}
            <div>
              <Typography variant="body2" fontWeight="500">
                Lender<span style={{ color: "red" }}> *</span>
              </Typography>
              <Select
                placeholder="Select Lender"
                options={lenderOptions}
                value={
                  lenderOptions.find(
                    (opt) => opt.value === supplyForm.lender
                  ) || null
                }
                onChange={(selectedOption: { value: any }) => {
                  setSupplyForm({
                    ...supplyForm,
                    lender: selectedOption?.value || "",
                  });
                  setSelectedLender(selectedOption);
                  if (selectedOption?.value) {
                    setSupplyFormErrors((prev) => ({
                      ...prev,
                      lender: false,
                    }));
                  }
                }}
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  control: (base: any, state: any) => ({
                    ...base,
                    minHeight: "36px",
                    height: "36px",
                    fontSize: "13px",
                    borderColor: supplyFormErrors.lender ? "red" : "#c4c4c4",
                    backgroundColor: "white",
                    boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : "none",
                  }),
                  valueContainer: (base: any) => ({
                    ...base,
                    height: "36px",
                    padding: "0 8px",
                    display: "flex",
                    alignItems: "center",
                  }),
                  input: (base: any) => ({
                    ...base,
                    margin: "0px",
                    padding: "0px",
                    height: "36px",
                  }),
                  indicatorsContainer: (base: any) => ({
                    ...base,
                    height: "36px",
                  }),
                  dropdownIndicator: (base: any) => ({
                    ...base,
                    padding: "0 8px",
                    height: "36px",
                    display: "flex",
                    alignItems: "center",
                  }),
                  clearIndicator: (base: any) => ({
                    ...base,
                    padding: "0 8px",
                    height: "36px",
                    display: "flex",
                    alignItems: "center",
                  }),
                  menu: (base: any) => ({
                    ...base,
                    backgroundColor: "white",
                    zIndex: 9999,
                  }),
                  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {supplyFormErrors.lender && (
                <Typography variant="caption" color="error">
                  Lender is required
                </Typography>
              )}
            </div>

            {/* Ticker */}
            <div>
              <Typography variant="body2" fontWeight="500">
                Ticker<span style={{ color: "red" }}> *</span>
              </Typography>
              <Select
                placeholder="Select Ticker"
                options={tickerOptions}
                components={{ MenuList: WindowedMenuList }}
                value={
                  tickerOptions.find(
                    (opt) => opt.value === supplyForm.ticker
                  ) || null
                }
                onChange={(selectedOption: { value: any }) => {
                  setSupplyForm({
                    ...supplyForm,
                    ticker: selectedOption?.value || "",
                  });
                  setSelectedTicker(selectedOption);
                  if (selectedOption?.value) {
                    setSupplyFormErrors((prev) => ({
                      ...prev,
                      ticker: false,
                    }));
                  }
                }}
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  control: (base: any, state: any) => ({
                    ...base,
                    minHeight: "36px",
                    height: "36px",
                    fontSize: "13px",
                    borderColor: supplyFormErrors.ticker ? "red" : "#c4c4c4",
                    backgroundColor: "white",
                    boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : "none",
                  }),
                  valueContainer: (base: any) => ({
                    ...base,
                    height: "36px",
                    padding: "0 8px",
                    display: "flex",
                    alignItems: "center",
                  }),
                  input: (base: any) => ({
                    ...base,
                    margin: "0px",
                    padding: "0px",
                    height: "36px",
                  }),
                  indicatorsContainer: (base: any) => ({
                    ...base,
                    height: "36px",
                  }),
                  dropdownIndicator: (base: any) => ({
                    ...base,
                    padding: "0 8px",
                    height: "36px",
                    display: "flex",
                    alignItems: "center",
                  }),
                  clearIndicator: (base: any) => ({
                    ...base,
                    padding: "0 8px",
                    height: "36px",
                    display: "flex",
                    alignItems: "center",
                  }),
                  menu: (base: any) => ({
                    ...base,
                    backgroundColor: "white",
                    zIndex: 9999,
                  }),
                  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {supplyFormErrors.ticker && (
                <Typography variant="caption" color="error">
                  Ticker is required
                </Typography>
              )}
            </div>

            <div>
              <Typography variant="body2" fontWeight="500">
                Quantity<span style={{ color: "red" }}> *</span>
              </Typography>
              <TextField
                fullWidth
                size="small"
                type="number"
                placeholder="Enter Quantity"
                value={supplyForm.quantity}
                onChange={(e) => {
                  const value = e.target.value;

                  if (value === "") {
                    setSupplyForm({ ...supplyForm, quantity: "" });
                    return;
                  }

                  const number = Number(value);

                  if (!Number.isInteger(number) || number < 1) return;

                  if (value.length > 12) {
                    setSupplyFormErrors((prev) => ({
                      ...prev,
                      quantity: true,
                    }));
                    setSupplyForm({ ...supplyForm, quantity: value });
                    return;
                  }

                  setSupplyForm({ ...supplyForm, quantity: value });

                  if (number >= 1) {
                    setSupplyFormErrors((prev) => ({
                      ...prev,
                      quantity: false,
                    }));
                  }
                }}
                inputProps={{
                  min: 1,
                  step: 1,
                  onKeyDown: (e) => {
                    if (["-", "e", ".", ","].includes(e.key)) {
                      e.preventDefault();
                    }
                  },
                }}
                error={supplyFormErrors.quantity}
                helperText={
                  supplyFormErrors.quantity
                    ? "Invalid Quantity – You cannot enter a quantity greater than 12 digits."
                    : ""
                }
                margin="dense"
                sx={{
                  "& .MuiInputBase-root": {
                    height: "36px",
                    fontSize: "13px",
                    padding: "0 8px",
                  },
                  "& input": {
                    height: "36px",
                    fontSize: "13px",
                    padding: "0 8px",
                  },
                }}
              />
            </div>

             <div>
              <Typography variant="body2" fontWeight="500">
                Rate{" "}
                <span style={{ color: "gray", fontWeight: 400 }}>
                  (Optional)
                </span>
              </Typography>

              <TextField
                fullWidth
                size="small"
                type="text"
                placeholder="Enter Rate (e.g. 123.0345)"
                value={supplyForm.rate}
                onChange={(e) => {
                  const value = e.target.value;
                  const regex = /^-?\d{0,3}(\.\d{0,4})?$/;
                  // const regex = /^-?\d*(\.\d{0,4})?$/;

                  if (value === "" || regex.test(value)) {
                    setSupplyForm({ ...supplyForm, rate: value });

                    if (supplyFormErrors?.rate) {
                      setSupplyFormErrors((prev: any) => ({
                        ...prev,
                        rate: false,
                      }));
                    }
                  }
                }}
                onBlur={() => {
                  const value = supplyForm.rate.trim();
                  const cleaned = value.replace(".", "");
                  const isAllZeros = /^0+$/.test(cleaned);

                  setSupplyFormErrors((prev: any) => ({
                    ...prev,
                    rate: isAllZeros,
                  }));
                }}
                error={supplyFormErrors?.rate || false}
                helperText={
                  supplyFormErrors?.rate
                    ? "Rate cannot be all zeros (e.g. 000.0000)"
                    : ""
                }
                margin="dense"
                sx={{
                  "& .MuiInputBase-root": {
                    height: "36px",
                    fontSize: "13px",
                    padding: "0 8px",
                  },
                  "& input": {
                    height: "36px",
                    fontSize: "13px",
                    padding: "0 8px",
                  },
                }}
              />
            </div>
          </div>
        </DialogContent>

        <DialogActions>
          <button
            className="btn btn-primary me-2"
            style={{
              opacity: 1,
              cursor: "pointer",
              backgroundColor: "#0d6efd",
              border: "1px solid #0d6efd",
              color: "#fff",
              height: "36px",
              fontSize: "13px",
              padding: "0 12px",
            }}
            onClick={() => {
              setSupplyForm({
                lender: "",
                ticker: "",
                quantity: "",
                rate: "",
              });
              setSelectedLender(null);
              setSelectedTicker(null);
              setSupplyFormErrors({
                lender: false,
                ticker: false,
                quantity: false,
                rate: false,
              });
              setIsSupplyPopupOpen(false);
            }}
          >
            Cancel
          </button>

          <button
            className="metrics-btn p-2 h-65 d-flex align-items-center btn btn-primary"
            onClick={submitSupplyData}
            style={{
              height: "40px",
              fontSize: "14px",
              padding: "0 16px",
            }}
          >
            Submit
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SupplyManagement;
